<template>
  <div>
    <div class="center">
      <div class="text-center">
        <img src="@/assets/fa/wrench.svg" width="86" height="86" alt="" />
      </div>
      <div class="text-center">
        <h2 data-cy="error" class="my-4">{{ $t('message.errorPage.Oops') }}</h2>
        <div>
          <p class="mx-auto">{{ $t('message.errorPage.testDriveError') }}</p>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <MobialisButton data-cy="returnHome" class="mt-4 col-11" @click="returnHome">{{
        $t('message.errorPage.errorButton')
      }}</MobialisButton>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ErrorPage',
  data() {
    return {};
  },
  methods: {
    returnHome() {
      this.$router.push({ name: `home-${this.baseRoute}` });
    },
  },
};
</script>

<style scoped lang="scss">
.center {
  margin-top: 118px;
}
p {
  max-width: 455px;
}
</style>
